import { useApi } from '@/api';
import { KpiCard } from '@/components';
import { useSearchParams } from '@/hooks';
import { tokensMapping } from '@/utils/tokens';
import { Flex } from '@blockanalitica/ui';

export default function SealKpis() {
  const [daysAgo] = useSearchParams('days_ago', '1');

  const [data, error] = useApi({
    url: '/lse/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <></>;
  }
  return (
    <Flex gap={['m', 's']} flexDirection="column">
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiCard
          title="Exit Fee"
          data={data}
          field="exit_fee"
          options={{
            percentage: true,
            trend: true,
            variants: { valuePercentageValue: 'dynamic' }
          }}
        />
        <KpiCard
          title="Exit Fee Collected"
          data={data}
          field="total_exit_fees"
          options={{
            currency: tokensMapping('MKR'),
            notation: 'compact',
            trend: true,
            variants: { valuePercentageValue: 'dynamic' }
          }}
        />
      </Flex>
    </Flex>
  );
}
